import { Button, Chip, TableCell, TableRow } from '@mui/material';
import { ProcessingRunData, TicketLogEntry } from '../../../interfaces/processing';
import { Link as RouterLink } from 'react-router-dom';
import { VENNIE_NOT_PROCESSED_STATUSES, VENNIE_PROCESSED_STATUSES } from '../../../constants/processing';

interface CustomerTicketRowProps {
  ticketLogEntry: TicketLogEntry;
  runs: Partial<ProcessingRunData>[];
}

export default function CustomerTicketRow({ ticketLogEntry, runs }: CustomerTicketRowProps) {
  const createdDate = new Date(ticketLogEntry.created_at);

  const sortedRuns = runs.sort((a, b) => {
    const dateA = b.created_at ?? '';
    const dateB = a.created_at ?? '';
    return new Date(dateB).getTime() - new Date(dateA).getTime();
  });

  const allStatuses = sortedRuns.map((run) => run.final_status);

  const isAnyProcessed = allStatuses.some((status: string | null | undefined) => VENNIE_PROCESSED_STATUSES.includes(status ?? ''));

  return (
    <TableRow hover>
      <TableCell component="th" scope="row">
        {ticketLogEntry.external_id}
      </TableCell>
      <TableCell><div style={{fontSize: '0.8rem', width: '110px'}}>{createdDate.toDateString()}</div></TableCell>
      <TableCell>{runs.length}</TableCell>
      <TableCell>
        <div style={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: isAnyProcessed ? '#4caf50' : '#f44336'
        }} />
      </TableCell>

      <TableCell>{allStatuses.map((status) => {
        if (status) {
          const isProcessed = VENNIE_PROCESSED_STATUSES.includes(status);
          const isNotProcessed = VENNIE_NOT_PROCESSED_STATUSES.includes(status);
          const circleColor = isProcessed ? '#4caf50' : isNotProcessed ? '#f44336' : '#9e9e9e';
          return (
            <Chip 
              key={status}
              label={status} 
              size="small" 
              style={{
                marginRight: '5px', 
                marginBottom: '5px',
                paddingLeft: '5px'
              }}
              icon={
                <div style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: circleColor,
                  marginRight: '3px'
                }} />
              }
            />
          );
        }
      })}</TableCell>
      <TableCell>
        <RouterLink to={`/ticket/${ticketLogEntry.id}`}>
          <Button variant="contained" color="primary" style={{width: '150px'}}>
            View Details
          </Button>
        </RouterLink>
      </TableCell>
    </TableRow>
  );
}
